import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ExEbDemandeTransporteur } from '../../classes/demandeTransporteur';
import { Statique } from '../../utils/statique';
import { EbDemande } from '../../classes/demande';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ConnectedUserComponent } from '../connectedUserComponent';

@Component({
	selector: 'app-pop-up-details-demande',
	templateUrl: './pop-up-details-demande.component.html',
	styleUrls: ['../modal/modal.component.css', './pop-up-details-demande.component.css']
})
export class PopUpDetailsDemandeComponent extends ConnectedUserComponent implements OnInit {

	Statique = Statique;

	@Input() ebDemande: EbDemande;
	@Input() module: number;
	@Input() isModal: boolean;
	@Input() exEbDemandeTransporteur: ExEbDemandeTransporteur;

	@Output() EditEventChange = new EventEmitter<boolean>();

	constructor(private modalService: NgbModal) {
		super()
	}

	ngOnInit() {
	}

	closePopUp(status: boolean) {

		this.EditEventChange.emit(status);
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/pop-up-details-demande/pop-up-details-demande.component.ts